import React from 'react'
import styles from './styles.module.scss'

export const BasicButton = ({ onClick, text, className }) => (
  <button
    onClick={onClick}
    className={`${styles.basicButton} ${className || ''}`}
  >
    <span>{text}</span>
  </button>
)
